export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.browser) {
    import("vue-credit-card-validation").then((VueCreditCardValidation) => {
      nuxtApp.vueApp.use(VueCreditCardValidation);
    });
  }
});
